export default "__VITE_ASSET__nFEWk4u6__"